// extracted by mini-css-extract-plugin
export default {"page":"style_page__uyQz+","header":"style_header__mNmY4","content":"style_content__juFWC"};